export default "__VITE_ASSET__UgVZm4U2__"